import { Button, Col, Row, Card, Modal, Form, Input, Tag } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import "react-phone-input-2/lib/style.css";
import { Severty, ShowToast } from "../../helper/toast";

import React, { useContext, useState, useEffect } from "react";
import { AuthContext, useAuthContext } from "../../context/AuthContext";
import useRequest from "../../hooks/useRequest";

import { useNavigate } from "react-router-dom";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import securepayment from "../../assets/images/secure-payment-fill.png";
import AccountSideNav from "../../components/layout/AccountSideNav";
import Footer from "../../components/layout/Footer";
import Header from "../../components/layout/Header";
import { BackArrow } from "./Index";
import { useAppContext } from "../../context/AppContext";

function PeymentMethod() {
  const { request } = useRequest();
  const { setUserProfile, userProfile } = useContext(AuthContext);
  const { isDarkTheme } = useAuthContext();

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { isMobile } = useAppContext();

  useEffect(() => {
    fetchBankDetails();
  }, []);

  const fetchBankDetails = () => {
    setLoading(true);
    request({
      url: "/app/bank-wire/bank-details",
      method: "GET",
      onSuccess: (res) => {
        setLoading(false);
        const listData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setList(listData);
      },
      onError: (error) => {
        setLoading(false);
      },
    });
  };

  const onFinish = (values) => {
    setLoading(true);
    const trimmedValues = {};
    for (const key in values) {
      if (typeof values[key] === "string") {
        trimmedValues[key] = values[key].trim();
      } else {
        trimmedValues[key] = values[key];
      }
    }
    request({
      url: "/app/bank-wire/add-bank-detail",
      method: "POST",
      data: trimmedValues,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          setVisible(false);
          form.resetFields();
          fetchBankDetails();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message || "Error adding bank account", Severty.ERROR);
      },
    });
  };

  const handleDeleteBank = (id) => {
    setLoading(true);
    request({
      url: `/app/bank-wire/delete-bank-detail/${id}`,
      method: "DELETE",
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          fetchBankDetails();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message || "Error removing bank account", Severty.ERROR);
      },
    });
  };

  return (
    <>
      <section className="main">
        <Header />
        <div className="account-outers">
          <Row>
            {!isMobile ? <AccountSideNav /> : <BackArrow />}
            <Col span={24} md={16} lg={18} xl={15} className="mx-auto">
              <div className="account-main">
                <div className="table-headding">Bank Accounts</div>
                <div className="payment-methods">
                  {list.length === 0 ? (
                    <>
                      <img src={securepayment} />
                      <h4>No Bank Accounts Available</h4>
                    </>
                  ) : (
                    <div className="bank-list w-100">
                      {list.map((item, index) => (
                        <Card 
                          key={index} 
                          className="mb-2"
                          style={{
                            background: isDarkTheme ? "#141414" : "#ffffff",
                            borderColor: isDarkTheme ? "#303030" : "#e8e8e8",
                            borderRadius: "12px"
                          }}
                        >
                          <Row justify="space-between" align="middle">
                            <Col>
                              <h6 style={{ 
                                color: isDarkTheme ? "#ffffff" : "#111111", 
                                fontWeight: "600", 
                                fontSize: "16px",
                                marginBottom: "4px"
                              }}>
                                {item.bankName}
                              </h6>
                              <p style={{ 
                                color: isDarkTheme ? "#a3a3a3" : "#595959",
                                margin: 0,
                                fontSize: "14px"
                              }}>
                                {item.accountNumber} - {item.accountName}
                                {item.routingNumber && ` (Routing: ${item.routingNumber})`}
                              </p>
                              {item.bankAddress && (
                                <p style={{ 
                                  color: isDarkTheme ? "#8c8c8c" : "#8c8c8c",
                                  margin: 0,
                                  fontSize: "12px",
                                  marginTop: "2px"
                                }}>
                                  Address: {item.bankAddress}
                                </p>
                              )}
                            </Col>
                            <Col style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                              {item.isDefault && <Tag color="green">Default</Tag>}
                              <Button 
                                type="text" 
                                danger 
                                icon={<DeleteOutlined />} 
                                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                onClick={() => {
                                  setSelectedBankId(item._id);
                                  setDeleteVisible(true);
                                }}
                              />
                            </Col>
                          </Row>
                        </Card>
                      ))}
                    </div>
                  )}
                  <div className="password-page-btn mt-4">
                    <Button
                      className="security-btn"
                      onClick={() => setVisible(true)}
                    >
                      Add New Bank Account
                    </Button>
                  </div>
                </div>

                <Modal
                  title={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontSize: "18px", fontWeight: "600" }}>Add Bank Account</span>}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  footer={null}
                  className="modal01"
                >
                  <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item 
                      name="bankName" 
                      label={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontWeight: "500" }}>Bank Name</span>} 
                      rules={[{ required: true, whitespace: true, message: "Please input Bank Name!" }]}
                    >
                      <Input style={{ 
                        background: isDarkTheme ? "#141414" : "#ffffff", 
                        color: isDarkTheme ? "#ffffff" : "#18181b",
                        borderColor: isDarkTheme ? "#434343" : "#d9d9d9"
                      }} />
                    </Form.Item>
                    <Form.Item 
                      name="accountName" 
                      label={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontWeight: "500" }}>Account Holder Name</span>} 
                      rules={[
                        { required: true, whitespace: true, message: "Please input Account Holder Name!" },
                        { pattern: /^[a-zA-Z\s]+$/, message: "Account Holder Name can only contain letters and spaces!" }
                      ]}
                    >
                      <Input style={{ 
                        background: isDarkTheme ? "#141414" : "#ffffff", 
                        color: isDarkTheme ? "#ffffff" : "#18181b",
                        borderColor: isDarkTheme ? "#434343" : "#d9d9d9"
                      }} />
                    </Form.Item>
                    <Form.Item 
                      name="accountNumber" 
                      label={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontWeight: "500" }}>Account Number</span>} 
                      rules={[
                        { required: true, whitespace: true, message: "Please input Account Number!" },
                        { pattern: /^\d{4,17}$/, message: "Account Number must be between 4 and 17 numeric digits!" }
                      ]}
                    >
                      <Input style={{ 
                        background: isDarkTheme ? "#141414" : "#ffffff", 
                        color: isDarkTheme ? "#ffffff" : "#18181b",
                        borderColor: isDarkTheme ? "#434343" : "#d9d9d9"
                      }} />
                    </Form.Item>
                    <Form.Item 
                      name="routingNumber" 
                      label={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontWeight: "500" }}>Routing Number</span>} 
                      rules={[
                        { required: true, whitespace: true, message: "Please input Routing Number!" },
                        { pattern: /^\d{9}$/, message: "Routing Number must be exactly 9 numeric digits!" }
                      ]}
                    >
                      <Input style={{ 
                        background: isDarkTheme ? "#141414" : "#ffffff", 
                        color: isDarkTheme ? "#ffffff" : "#18181b",
                        borderColor: isDarkTheme ? "#434343" : "#d9d9d9"
                      }} maxLength={9} />
                    </Form.Item>
                    <Form.Item 
                      name="bankAddress" 
                      label={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontWeight: "500" }}>Bank Address</span>} 
                      rules={[{ required: true, whitespace: true, message: "Please input Bank Address!" }]}
                    >
                      <Input style={{ 
                        background: isDarkTheme ? "#141414" : "#ffffff", 
                        color: isDarkTheme ? "#ffffff" : "#18181b",
                        borderColor: isDarkTheme ? "#434343" : "#d9d9d9"
                      }} />
                    </Form.Item>
                    <Form.Item 
                      name="iban" 
                      label={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontWeight: "500" }}>IBAN (Optional)</span>}
                      rules={[{ pattern: /^[A-Z]{2}\d{2}[A-Z0-9]{4,30}$/, message: "Please enter a valid IBAN format!" }]}
                    >
                      <Input style={{ 
                        background: isDarkTheme ? "#141414" : "#ffffff", 
                        color: isDarkTheme ? "#ffffff" : "#18181b",
                        borderColor: isDarkTheme ? "#434343" : "#d9d9d9"
                      }} />
                    </Form.Item>
                    <Form.Item 
                      name="swiftCode" 
                      label={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontWeight: "500" }}>Swift/BIC (Optional)</span>}
                      rules={[{ pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/, message: "Please enter a valid Swift/BIC code!" }]}
                    >
                      <Input style={{ 
                        background: isDarkTheme ? "#141414" : "#ffffff", 
                        color: isDarkTheme ? "#ffffff" : "#18181b",
                        borderColor: isDarkTheme ? "#434343" : "#d9d9d9"
                      }} />
                    </Form.Item>
                    <Form.Item>
                      <Button 
                        type="primary" 
                        htmlType="submit" 
                        loading={loading} 
                        block
                        style={{
                          backgroundColor: "#65C953",
                          borderColor: "#65C953",
                          color: "#ffffff",
                          fontWeight: "600",
                          height: "40px",
                          borderRadius: "8px"
                        }}
                      >
                        Save Bank Account
                      </Button>
                    </Form.Item>
                  </Form>
                </Modal>

                <Modal
                  title={<span style={{ color: isDarkTheme ? "#ffffff" : "#18181b", fontSize: "18px", fontWeight: "600" }}>Delete Bank Account</span>}
                  visible={deleteVisible}
                  onCancel={() => setDeleteVisible(false)}
                  footer={null}
                  className="modal01"
                  width={400}
                >
                  <div style={{ textAlign: "center", padding: "10px 0" }}>
                    <p style={{ color: isDarkTheme ? "#a3a3a3" : "#595959", fontSize: "16px", marginBottom: "24px" }}>
                      Are you sure you want to delete this bank account?
                    </p>
                    <Row gutter={16} justify="center">
                      <Col span={12}>
                        <Button 
                          onClick={() => setDeleteVisible(false)} 
                          block
                          style={{
                            background: isDarkTheme ? "#2c2c2e" : "#e5e5e7",
                            color: isDarkTheme ? "#ffffff" : "#000000",
                            borderColor: "transparent",
                            borderRadius: "8px"
                          }}
                        >
                          No
                        </Button>
                      </Col>
                      <Col span={12}>
                        <Button 
                          type="primary"
                          danger
                          onClick={() => {
                            handleDeleteBank(selectedBankId);
                            setDeleteVisible(false);
                          }} 
                          block
                          style={{
                            borderRadius: "8px"
                          }}
                        >
                          Yes, Delete
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Modal>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default PeymentMethod;
